import React from 'react'

const ProfileArea = ({ userProfile }) => {
  const profileItems = [
    { label: 'Name', value: userProfile?.name || 'Not added' },
    { label: 'Email', value: userProfile?.email || 'Not added' },
    { label: 'Company Name', value: userProfile?.companyName || userProfile?.company_name || 'Not added' },
    { label: 'Contact No', value: userProfile?.contact || 'Not added' },
    { label: 'Insurance Type', value: userProfile?.insuranceType || userProfile?.insurance_type || 'Not added' },
    { label: 'Partner Type', value: userProfile?.partnerType || userProfile?.partner_type || 'Not added' },
    { label: 'Service', value: userProfile?.service || 'Not added' },
    { label: 'Bill Due', value: userProfile?.billAmount || userProfile?.bill_amount || '0' },
  ]

  return (
    <div className='mx-4 my-6 md:mx-6'>
      <div className='grid gap-6 xl:grid-cols-[minmax(0,1.2fr)_minmax(0,0.8fr)]'>
        <div className='rounded-[28px] border border-slate-200 bg-white px-6 py-6 shadow-[0_18px_42px_rgba(15,23,42,0.07)]'>
          <div className='mb-5 border-b border-slate-100 pb-4'>
            <p className='text-sm font-[GilroyBold] uppercase tracking-[0.14em] text-slate-400'>Account information</p>
            <p className='mt-1 text-sm text-slate-500'>Primary profile information attached to this logistics account.</p>
          </div>
          <div className='grid gap-5 md:grid-cols-2'>
            {profileItems.map((item) => (
              <div key={item.label} className='rounded-[22px] border border-slate-200 bg-[linear-gradient(180deg,_#ffffff,_#f8fafc)] px-4 py-4'>
                <p className='text-[11px] font-[GilroyBold] uppercase tracking-[0.14em] text-slate-400'>{item.label}</p>
                <p className='mt-2 text-sm font-[GilroyBold] text-slate-900 break-words'>{item.value}</p>
              </div>
            ))}
          </div>
        </div>

        <div className='space-y-5'>
          <div className='rounded-[28px] border border-slate-200 bg-white px-6 py-6 shadow-[0_18px_42px_rgba(15,23,42,0.07)]'>
            <p className='text-sm font-[GilroyBold] uppercase tracking-[0.14em] text-slate-400'>Identity snapshot</p>
            <div className='mt-5 flex items-center gap-4'>
              <div className='flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-[#fb923c] via-[#f97316] to-[#0f172a] text-xl font-[GilroyBold] text-white shadow-[0_12px_28px_rgba(37,99,235,0.22)]'>
                {(userProfile?.name || userProfile?.company_name || 'A').charAt(0).toUpperCase()}
              </div>
              <div>
                <p className='text-lg font-[GilroyBold] text-slate-950'>{userProfile?.companyName || userProfile?.company_name || userProfile?.name || 'Account User'}</p>
                <p className='mt-1 text-sm font-[GilroyMedium] text-slate-500'>{userProfile?.email || 'No email available'}</p>
              </div>
            </div>
          </div>

          <div className='rounded-[28px] border border-slate-200 bg-[linear-gradient(180deg,_#0f172a,_#111827)] px-6 py-6 text-white shadow-[0_20px_40px_rgba(15,23,42,0.22)]'>
            <p className='text-[10px] font-[GilroyBold] uppercase tracking-[0.18em] text-slate-400'>Profile status</p>
            <div className='mt-4 space-y-4'>
              <div className='rounded-[18px] bg-white/5 px-4 py-4'>
                <p className='text-xs text-slate-400'>Account role</p>
                <p className='mt-1 text-2xl font-[GilroyBold]'>{userProfile?.role || 'User'}</p>
              </div>
              <div className='rounded-[18px] bg-white/5 px-4 py-4'>
                <p className='text-xs text-slate-400'>Partner type</p>
                <p className='mt-1 text-lg font-[GilroyBold]'>{userProfile?.partnerType || userProfile?.partner_type || 'Not configured'}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProfileArea
